import {
  correspondenceQueryKeys,
  CorrespondenceThreadRoute,
} from "toptaal-shared"
import { createFileRoute, useParams, useRouter } from "@tanstack/react-router"
import { CorrespondenceEntityType } from "toptaal-shared"
import { useOrganizationUserQuery } from "@/api/queries/organizationUser/useOrganizationUserQuery"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"

export const Route = createFileRoute(
  "/beheer/contracten/$contractId/correspondentie/$threadId",
)({
  component: RouteComponent,
  beforeLoad: async () => {
    return checkOrganizationPermissions("read", "projectCorrespondence")
  },
})

function RouteComponent() {
  const router = useRouter()
  const { data: user } = useOrganizationUserQuery()

  const { contractId: contractIdParam, threadId: threadIdParam } = useParams({
    from: "/beheer/contracten/$contractId/correspondentie/$threadId",
  })

  const entityType: CorrespondenceEntityType = "Project"
  const threadId = Number(threadIdParam)
  const entityId = Number(contractIdParam)

  const handleNavigateBack = () => {
    router.navigate({
      to: `/beheer/contracten/${contractIdParam}/correspondentie`,
    })
  }

  return (
    <CorrespondenceThreadRoute
      threadId={threadId}
      entityType={entityType}
      entityId={entityId}
      user={user}
      correspondenceQueryKeys={correspondenceQueryKeys}
      onNavigateBack={handleNavigateBack}
      showEditButton={false}
    />
  )
}
